/*
 * 注册全局组件 管理文件
 */

import Vue from "vue"; // 引入vue

// 处理首字母大写 abc => Abc

function changeStr(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

/*
    require.context(arg1,arg2,arg3)
        arg1 - 读取文件的路径
        arg2 - 是否遍历文件的子目录
        arg3 - 匹配文件的正则
    ./globalComponents 需要全局注册组件的文件夹
*/

const requireComponent = require.context(
  "./globalComponents",
  true,
  /\.vue$/,
  "lazy"
);
// console.log('requireComponent.keys():', requireComponent.keys()) // 动态引入的组件路径
requireComponent.keys().forEach((fileName) => {
  const componentName = changeStr(
    fileName.replace(/^\.\//, "").replace(/\.\w+$/, "") // ./child1.vue => child1
  );
  Vue.component(componentName, async () => {
    const config = await Promise.resolve(requireComponent(fileName));
    // console.log("config:", config); // 打印
    return config.default || config;
  }); // 动态注册该目录下的所有.vue文件
});
